import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "section" }
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = { class: "section columns my-rem2 justify-center items-center" }
const _hoisted_5 = { class: "polaroid-frame max-w-xs" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "image-subtitle" }
const _hoisted_8 = { class: "polaroid-frame max-w-xs" }
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "image-subtitle" }
const _hoisted_11 = { class: "section columns" }
const _hoisted_12 = ["innerHTML"]
const _hoisted_13 = ["innerHTML"]
const _hoisted_14 = { class: "flex flex-col" }
const _hoisted_15 = ["innerHTML"]
const _hoisted_16 = { class: "section columns" }
const _hoisted_17 = ["innerHTML"]
const _hoisted_18 = { class: "flex justify-center items-center my-rem2" }
const _hoisted_19 = { class: "section sm:mt-rem5 lg:text-center" }

import ArticleModalContent from '@/components/ArticleModalContent.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'Beljenje',
  emits: ["close", "navigate"],
  setup(__props) {



return (_ctx: any,_cache: any) => {
  const _component_a_info_panel = _resolveComponent("a-info-panel")!
  const _component_a_circular_image = _resolveComponent("a-circular-image")!

  return (_openBlock(), _createBlock(ArticleModalContent, {
    title: _ctx.$t('articles.beljenje.title'),
    cover: require('@/assets/covers/opalescence.jpg'),
    "close-button-dark": true,
    onClose: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close')))
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("p", {
          innerHTML: _ctx.$t('articles.beljenje.intro')
        }, null, 8, _hoisted_2)
      ]),
      _createElementVNode("p", {
        class: "mt-4 font-bold",
        innerHTML: _ctx.$t('articles.beljenje.clinicalP')
      }, null, 8, _hoisted_3),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("img", {
            src: require('@/assets/beljenje-before.jpg'),
            loading: "lazy",
            alt: ""
          }, null, 8, _hoisted_6),
          _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.$t('articles.beljenje.beforeLabel')), 1)
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("img", {
            src: require('@/assets/beljenje-after.jpg'),
            loading: "lazy",
            alt: ""
          }, null, 8, _hoisted_9),
          _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.$t('articles.beljenje.afterLabel')), 1)
        ])
      ]),
      _cache[6] || (_cache[6] = _createElementVNode("hr", null, null, -1)),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", null, [
          _createElementVNode("h2", null, _toDisplayString(_ctx.$t('articles.beljenje.inOfficeTitle')), 1),
          _createElementVNode("p", {
            innerHTML: _ctx.$t('articles.beljenje.inOfficeP1')
          }, null, 8, _hoisted_12),
          _createVNode(_component_a_info_panel, {
            icon: require('@/assets/png-icons/warning.png'),
            class: "mb-rem2 narrow-text"
          }, {
            default: _withCtx(() => [
              _createElementVNode("p", {
                innerHTML: _ctx.$t('articles.beljenje.inOfficeWarning')
              }, null, 8, _hoisted_13)
            ]),
            _: 1
          }, 8, ["icon"]),
          _cache[2] || (_cache[2] = _createElementVNode("div", { class: "polaroid-frame w-full" }, [
            _createElementVNode("iframe", {
              title: "opalescence",
              height: "250px",
              src: "https://www.youtube.com/embed/WmBjFcHsfEY",
              frameborder: "0",
              allowfullscreen: ""
            }),
            _createElementVNode("p", { class: "!m-0" }, "Opalescence Boost")
          ], -1))
        ]),
        _cache[4] || (_cache[4] = _createElementVNode("hr", { class: "mobile-only" }, null, -1)),
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("h2", null, _toDisplayString(_ctx.$t('articles.beljenje.customTrayTitle')), 1),
          _createElementVNode("p", {
            innerHTML: _ctx.$t('articles.beljenje.customTrayP')
          }, null, 8, _hoisted_15),
          _cache[3] || (_cache[3] = _createElementVNode("div", { class: "polaroid-frame w-full mt-auto" }, [
            _createElementVNode("iframe", {
              title: "opalescence",
              height: "250px",
              src: "https://www.youtube.com/embed/i99fb1-WRQg",
              frameborder: "0",
              allowfullscreen: ""
            }),
            _createElementVNode("p", { class: "!m-0" }, "Opalescence PF Take-Home")
          ], -1))
        ])
      ]),
      _cache[7] || (_cache[7] = _createElementVNode("hr", null, null, -1)),
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("div", null, [
          _createElementVNode("h2", null, _toDisplayString(_ctx.$t('articles.beljenje.takehomeTitle')), 1),
          _createElementVNode("p", {
            innerHTML: _ctx.$t('articles.beljenje.takehomeP')
          }, null, 8, _hoisted_17),
          _cache[5] || (_cache[5] = _createElementVNode("div", { class: "polaroid-frame w-full" }, [
            _createElementVNode("iframe", {
              title: "opalescence",
              height: "250px",
              src: "https://www.youtube.com/embed/p29HFG39SH4",
              frameborder: "0",
              allowfullscreen: ""
            }),
            _createElementVNode("p", { class: "!m-0" }, "Opalescence Go")
          ], -1))
        ]),
        _createElementVNode("div", _hoisted_18, [
          _createVNode(_component_a_circular_image, {
            image: require('@/assets/photos/urska-katja.jpg'),
            class: "big sm-big mt-rem1"
          }, null, 8, ["image"])
        ])
      ]),
      _createElementVNode("div", _hoisted_19, [
        _createTextVNode(_toDisplayString(_ctx.$t('articles.beljenje.cenikPre')), 1),
        _createElementVNode("b", {
          class: "internal-link",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('navigate', 'cenik', 'estetika')))
        }, _toDisplayString(_ctx.$t('articles.beljenje.cenikLinkText')), 1),
        _createTextVNode(_toDisplayString(_ctx.$t('articles.beljenje.cenikPost')), 1)
      ])
    ]),
    _: 1
  }, 8, ["title", "cover"]))
}
}

})